module.exports = __webpack_public_path__ + "img/Indonesia-09.dc76de06.jpg";